import { c as _c } from "react/compiler-runtime";
import { formatBytes } from '@/util/i18n/format-bytes';
import { useMemo } from 'react';
// import { useLocaleContext } from '../../providers/locale'

export interface FormatByteProps {
  /**
   * The unit granularity to display
   */
  unit?: 'bit' | 'byte';
  /**
   * The unit display
   */
  unitDisplay?: 'long' | 'short' | 'narrow';
  /**
   * The byte size to format
   */
  value: number;
}
export const FormatByte = props => {
  const $ = _c(4);
  const locale = "en-US";
  let t0;
  if ($[0] !== props) {
    const {
      value,
      ...intlOptions
    } = props;
    t0 = formatBytes(value, "en-US", intlOptions);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const text = t0;
  let t1;
  if ($[2] !== text) {
    t1 = <>{text}</>;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
FormatByte.displayName = 'FormatByte';